/**
 * Convert to full URL
 * @author Brendan Magee, Umer Hassan
 */

function urlConversionService($q, $log, siteService) {
  const service = {};

  service.expandURL = (story = {}) => {
    const { url, primarySection } = story;
    if (url && url.slice(0, 4).toLowerCase() === 'http') {
      return $q.when(url);
    } else if (url && url.slice(0, 1) === '/') {
      return siteService.getWebsites()
        .then((res) => {
          const urlWebsite = res.find(site => site._id === primarySection.website)
            || { base_path: null };
          let basePath = urlWebsite.base_path;

          if (basePath && basePath.slice(0, 4).toLowerCase() === 'http') {
            const lastIndex = basePath.length - 1;
            basePath = basePath.slice(lastIndex) === '/' ? basePath.slice(0, lastIndex) : basePath;
            return $q.when(basePath + url);
          }

          return $q.when(null);
        }, () => {
          $log.error('Error getting websites in `urlConversionService`');
          return $q.when(null);
        });
    }

    return $q.when(null);
  };

  return service;
}

const serviceArray = [
  '$q',
  '$log',
  'siteService',
  urlConversionService
];

module.exports = (ngModule) => {
  ngModule.service('urlConversionService', serviceArray);
};
